import React from 'react';
import { StepContainer, BoldText, BoldParagraph, Paragraph } from '../tutorial.styles';
var PrimeiroStep = function () { return (React.createElement(StepContainer, null,
    React.createElement(BoldText, null, "OL\u00C1!"),
    React.createElement(BoldParagraph, null, "Seja bem vindo(a)!"),
    React.createElement(Paragraph, null, "Vamos fazer um tour pela aplica\u00E7\u00E3o!"),
    React.createElement(Paragraph, null, "Aqui voc\u00EA encontrar\u00E1 tudo que precisa para facilitar o seu trabalho."),
    React.createElement(BoldParagraph, { style: { marginTop: '40%' } }, "Vamos ao Tutorial"))); };
export default PrimeiroStep;
